import React from 'react';
import { WrenchIcon, TargetIcon, UsersIcon } from 'lucide-react';
import { whyAdroi } from '../../data/crm';
const icons = [WrenchIcon, TargetIcon, UsersIcon];
export function WhyAdroiCrm() {
  return <section className="bg-white px-4 py-20 sm:px-6 lg:px-8 lg:py-28" data-id="element-322" data-mp="z2zar640l3fc">
      <div className="mx-auto max-w-7xl" data-id="element-323" data-mp="u3moonkyw0dt">
        <h2 className="max-w-2xl text-3xl font-extrabold tracking-tight text-brand-black sm:text-4xl" data-id="element-324" data-mp="u4pcunqwnoq1">
          Why get 1Dash.Pro from <span className="text-brand-red" data-id="element-325" data-mp="6ebkew4ernux">Ad ROI</span>
        </h2>
        <div className="mt-14 grid gap-12 md:grid-cols-3 md:gap-10" data-id="element-326" data-mp="2dhw41n2071i">
          {whyAdroi.map((item, i) => {
          const Icon = icons[i];
          return <div key={item.title} className="border-t-2 border-brand-black pt-6" data-id="element-327" data-mp="bdepggke1u2w" data-mpi={i}>
                <Icon className="h-6 w-6 text-brand-red" strokeWidth={1.75} aria-hidden="true" data-id="element-328" data-mp="3jsygd8xl70es" />
                <h3 className="mt-5 text-xl font-bold text-brand-black" data-id="element-329" data-mp="3jqlskf55dvtt">{item.title}</h3>
                <p className="mt-3 text-base leading-relaxed text-gray-600" data-id="element-330" data-mp="3ersjr00t2szz">{item.body}</p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}